import nl from './nl';
import en from './en';
import de from './de';
import * as Sentry from '@sentry/browser';

type TranslationMap = Record<string, string | ((...args: any[]) => string)>;
type TranslationValue = string | TranslationMap | Array<unknown>;
type Translations = Record<string, Record<string, TranslationValue>>;

const translations: Translations = { nl, en, de };
let _locale = 'nl';
let _current: Record<string, any> = nl;
let _listeners: Array<() => void> = [];

export function setLocale(locale: string): void {
  if (translations[locale]) {
    _locale = locale;
    _current = translations[locale];
    _listeners.forEach(l => l());
  }
}

export function getLocale(): string {
  return _locale;
}

export function t(key: string, params?: Record<string, string | number>): string {
  const value = _current[key];
  if (typeof value === 'function') {
    return value(params);
  }
  if (typeof value === 'string' && params) {
    return value.replace(/\{\{(\w+)\}\}/g, (_, name) => String(params[name] ?? ''));
  }
  if (value === undefined) {
    Sentry.captureMessage(`no translation found for ${_locale}.${key}`);
    return key;
  }
  return value;
}

export function onLocaleChange(callback: () => void): () => void {
  _listeners.push(callback);
  return () => { _listeners = _listeners.filter(l => l !== callback); };
}

export { nl, en, de };
